// src/api/TICKET/interventionTicket.js

const API_URL = process.env.REACT_APP_API_URL;


//GET interventions by ticket ID
export async function getInterventionsByTicket(ticketId) {
  const response = await fetch(
    `${API_URL}/ticket/${ticketId}/interventions`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Erreur chargement interventions");
  }
  return response.json();
}


export async function postIntervention(ticketId, interventionData) {
  const response = await fetch(
    `${API_URL}/ticket/${ticketId}/intervention`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(interventionData),
    }
  );

  if (!response.ok) {
    throw new Error("Erreur création intervention");
  }

  return response.json();
}

export async function updateIntervention(ticketId, interventionId, interventionData) {
  const response = await fetch(
    `${API_URL}/ticket/${ticketId}/intervention/${interventionId}`,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(interventionData),
    }
  );

  if (!response.ok) {
    throw new Error("Erreur mise à jour intervention");
  }

  return response.json();
}

export const deleteIntervention = (ticketId, interventionId) => {
  return fetch(
    `${API_URL}/ticket/${ticketId}/intervention/${interventionId}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    }
    
  );
};